import { Fragment, useState, useRef } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Combobox,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate, useParams } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  PlusIcon,
  ArchiveIcon,
  SortAscendingIcon,
  ExclamationIcon,
  XIcon,
  ClipboardIcon,
  DocumentIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class InvoicerecordpaymentEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      customer_id: "",
      customerDetails: "",
      invoiceNumber: "",
      invoice_idcrypt: "",
      invoice_date: "",
      payment_terms_id: "",
      due_date: "",
      balance_due: 0,
      invoiceTaxlist: [],
      customerList: [],
      itemLine: [],
      termsList: [],
      branchList: [],
      error_list: [],
      discountList: [],
      invoiceDetails: [],
      query: "",
      queryItem: "",
      selectedPerson: "",
      selectedItems: "",
      paymentmode: [],
      taxdeducted: [],
      invoice_id: "",
      branch_id: "",
      amount_received: "",
      pan: "",
      tax_deducted_option_customer_payment_received_id: "",
      payment_date: "",
      mode_of_payment_id: "",
      reference: "",
      notes: "",
      paymentList: [],
      deletealartmsg: false,
      overLay: "",
      loader: "",
      message: "",
    };
    //  this.handleInput = this.handleInput.bind(this);
    //this.addLine = this.addLine.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;

    const ress = axios
      .get("public/api/customer/payment/received/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.setState({
          invoiceDetails: ress.data.customer_payment_received,
          invoice_id: ress.data.customer_payment_received.invoice.id,
          invoice_idcrypt: ress.data.customer_payment_received.invoice.id_crypt,
          customer_id: ress.data.customer_payment_received.invoice.customer_id,
          branch_id: ress.data.customer_payment_received.branch_id,
          invoiceNumber:
            ress.data.customer_payment_received.invoice
              .transaction_series_number,
          amount_received: ress.data.customer_payment_received.amount_received,
          pan: ress.data.customer_payment_received.pan,
          tax_deducted_option_customer_payment_received_id:
            ress.data.customer_payment_received
              .tax_deducted_option_customer_payment_received_id,
          payment_date: ress.data.customer_payment_received.payment_date,
          mode_of_payment_id:
            ress.data.customer_payment_received.mode_of_payment_id,
          reference: ress.data.customer_payment_received.reference,
          notes: ress.data.customer_payment_received.notes,

          invoice_date:
            ress.data.customer_payment_received.invoice.invoice_date,
          payment_terms_id:
            ress.data.customer_payment_received.invoice.payment_terms_id,
          due_date: ress.data.customer_payment_received.invoice.due_date,
          customerDetails:
            ress.data.customer_payment_received.invoice
              .customer_details_for_pagination,
          balance_due: ress.data.customer_payment_received.invoice.balance_due,
        });
      });

    const res = axios
      .get("public/api/customers", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ customerList: res.data.customers });
      });

    const res2 = axios
      .get("public/api/paymentterms", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ termsList: res2.data.paymentterms });
      });

    const res3 = axios
      .get("public/api/invoice/tax/option", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ invoiceTaxlist: res3.data.invoice_tax_option });
      });

    const res4 = axios
      .get("public/api/customer/payment/received/tax/deducted", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({ taxdeducted: res4.data.tax_deducted });
      });

    const res6 = axios
      .get("public/api/modeofpayment", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res6) => {
        this.setState({ paymentmode: res6.data.mode_of_payment });
      });

    const res7 = axios
      .get("public/api/customer/payment/received/pagination", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res7) => {
        //console.log(res7.data.customer_payment_received.data);
        this.setState({
          paymentList: res7.data.customer_payment_received.data,
        });
        console.log(this.state.paymentList);
      });

    const res12 = axios
      .get("public/api/branch", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res12) => {
        this.setState({ branchList: res12.data.branches });
      });

    this.closeLoaderFuncion();
  }

  handleInputpaymentdetails = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("public/api/customer/payment/received/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({ deleteRedirect: true });
            this.setState({ deletealartmsg: false });
          }
        });
    }
  };

  saveItem = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();
    const { id } = this.props.params;

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/customer/payment/received/update/" + id,
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.state.message = "Successfully Saved";
      this.setState({ message: this.state.message });
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      if (res.data.data != undefined) {
        this.state.error_list = res.data.data;
        this.setState({ error_list: this.state.error_list });
      } else {
        this.state.error_list = null;
        this.setState({ error_list: this.state.error_list });
        this.state.message = res.data.message;
        this.setState({ message: this.state.message });
        this.setState({ showmsg: true });

        setTimeout(
          function () {
            this.setState({ message: "" });
            this.setState({ showmsg: false });
          }.bind(this),
          1000
        );
      }
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    const cancelButtonRef = null;

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/filterby/Invoiceview/" + this.state.invoice_idcrypt} />;
    }

    const filteredPeople =
      this.state.query === ""
        ? this.state.customerList
        : this.state.customerList.filter((customerList) => {
            return customerList.customer_display_name
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });

    const filteredItem =
      this.state.queryItem === ""
        ? this.state.itemLine
        : this.state.itemLine.filter((itemLine) => {
            return itemLine.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />
          

          {/* Static sidebar for desktop */}
          
         
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Record Payment
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.saveItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                {/*start*/}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-4">
                                  <label
                                    htmlFor="customer_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Customer Name
                                  </label>
                                  <input
                                    type="text"
                                    name="customer_id"
                                    id="customer_id"
                                    disabled
                                    value={
                                      this.state.customerDetails
                                        .primary_contact_first_name
                                    }
                                    readOnly
                                    autoComplete="customer_id"
                                    className="mt-1 focus:ring-indigo-500 disabled:bg-slate-50 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="branch_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Branch:
                                  </label>
                                  <select
                                    id="branch_id"
                                    name="branch_id"
                                    disabled
                                    value={this.state.branch_id}
                                    onChange={this.handleInputpaymentdetails}
                                    readOnly
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.branchList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="invoiceNumber"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Invoice Number
                                  </label>
                                  <input
                                    type="text"
                                    name="invoiceNumber"
                                    id="invoiceNumber"
                                    disabled
                                    value={this.state.invoiceNumber}
                                    readOnly
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="invoiceNumber"
                                    className="mt-1 focus:ring-indigo-500 disabled:bg-slate-50 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="invoice_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Invoice Date
                                  </label>
                                  <input
                                    type="Date"
                                    name="invoice_date"
                                    id="invoice_date"
                                    value={this.state.invoice_date}
                                    disabled
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete=""
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="payment_terms_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Terms
                                  </label>
                                  <select
                                    id="payment_terms_id"
                                    name="payment_terms_id"
                                    value={this.state.payment_terms_id}
                                    disabled
                                    onChange={this.handleInputpaymentdetails}
                                    readOnly
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.termsList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="due_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Due Date
                                  </label>
                                  <input
                                    type="date"
                                    name="due_date"
                                    id="due_date"
                                    value={this.state.due_date}
                                    readOnly
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="due_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="amount_received"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Amount Received(INR)*
                                  </label>
                                  <input
                                    type="number"
                                    name="amount_received"
                                    id="amount_received"
                                    value={this.state.amount_received}
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="amount_received"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="amount_received-error"
                                  >
                                    {this.state.error_list?.amount_received}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="amount_received"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    PAN:
                                  </label>
                                  <input
                                    type="text"
                                    name="pan"
                                    id="pan"
                                    value={this.state.pan}
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="pan"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="pan-error"
                                  >
                                    {this.state.error_list?.pan}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="tax_deducted_option_customer_payment_received_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Tax deducted?
                                  </label>
                                  <select
                                    id="tax_deducted_option_customer_payment_received_id"
                                    name="tax_deducted_option_customer_payment_received_id"
                                    value={
                                      this.state
                                        .tax_deducted_option_customer_payment_received_id
                                    }
                                    onChange={this.handleInputpaymentdetails}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.taxdeducted.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  ></p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="payment_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Payment Date*
                                  </label>
                                  <input
                                    type="Date"
                                    name="payment_date"
                                    id="payment_date"
                                    value={this.state.payment_date}
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="payment_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="payment_date-error"
                                  >
                                    {this.state.error_list?.payment_date}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="mode_of_payment_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Payment Mode
                                  </label>
                                  <select
                                    id="mode_of_payment_id"
                                    name="mode_of_payment_id"
                                    value={this.state.mode_of_payment_id}
                                    onChange={this.handleInputpaymentdetails}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.paymentmode.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list?.mode_of_payment_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="reference"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Reference#
                                  </label>
                                  <input
                                    type="text"
                                    name="reference"
                                    id="reference"
                                    value={this.state.reference}
                                    onChange={this.handleInputpaymentdetails}
                                    autoComplete="reference"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="pan-error"
                                  >
                                    {this.state.error_list?.reference}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="notes"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Notes
                                  </label>
                                  <div className="sm:col-span-3">
                                    <div className="mt-1">
                                      <textarea
                                        rows={2}
                                        name="notes"
                                        value={this.state.notes}
                                        id="notes"
                                        onChange={
                                          this.handleInputpaymentdetails
                                        }
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                        defaultValue={""}
                                      />
                                    </div>
                                  </div>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="notes-error"
                                  >
                                    {this.state.error_list?.notes}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-3">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Record Payment
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/**/}

        {/**/}
      </>
    );
  }
}

export default (props) => (
  <InvoicerecordpaymentEdit {...props} params={useParams()} />
);
